import * as types from './types'
import {userProfile} from '../storage.js';

const state = userProfile.get() || {
  type: 0,
  isSuper: 0,
  loanName: '',
  loanMenuList: [],
  menuLimit:[]
};

const mutations = {
  [types.SAVE_USER_INFO]: (state, payload) => {
    Object.keys(payload).forEach(function (key) {
      state[key] = payload[key];
    });
    // state.type = payload.type;
    // state.isSuper = payload.isSuper;
    // state.loanName = payload.loanName;
    // state.loanMenuList = payload.loanMenuList;
    // state.menuLimit = payload.menuLimit;
    userProfile.set(state);
  },

  [types.EMPTY_USER_INFO]: (state) => {
    state.type = 0;
    state.isSuper = 0;
    state.loanName = '';
    state.loanMenuList = [];
    userProfile.clear();
  },

};


export default ({
  state,
  mutations,
})
